import React, { useEffect, useState, useRef } from "react";
import validator from "validator";
import Leftsiderbar from "../home/allcmp/Leftsidebar";
import { makeStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
  Typography,
} from "@material-ui/core";
import MaterialTable from "material-table";
import Top from "../Top";
import { API_URL } from "../../../config";
import { Button, Modal, ModalHeader, ModalBody, Row } from "reactstrap";
import EditDevice from "./EditDevice";
import Viewlog from "./Viewlog";
import Viewlinkedlog from "./Viewlinkedlog";
import logimg from "../../images/log.png";
import { useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditDevice6 from "./EditDevice6";
import EditDevice5 from "../Devices5/EditDevice5";

const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: "black",
    fontSize: "15px",
  },
}));

const GodeviceOwnerAccordian5 = (props) => {
  const classes = useStyles();
  const navigation = useNavigate();
  const _ownnerId = props.id;

  const [data, setData] = useState([]);
  const [data7, setData7] = useState([]);
  const [data6, setData6] = useState([]);
  const [data5, setData5] = useState([]);
  // const [databyid, setdatabyid] = useState([]);
  const [distributorName, setDistributorName] = useState("");
  // ====================
  const [ownerName, setOwnerName] = useState("");
  const [firstName1, setFirstName1] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password1, setPassword1] = useState("");
  const [telephone1, setTelephone1] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [age, setAge] = useState("");
  const [country, setCountry] = useState("");
  const [gender, setGender] = useState("");
  const [popData1, setPopData1] = useState({});
  const [GoToggle, setGoToggle] = useState(false);
  const [Device5, setDevice5] = useState(false);
  const [Device6, setDevice6] = useState(false);
  const [URL, setURL] = useState("");
  // ==================

  const [databyid, setdatabyid] = useState([]);
  const [checkboxshow, setCheckboxshow] = useState(false);
  const [cmoduleval, setCmoduleval] = useState(0);
  const [mmoduleval, setMmoduleval] = useState(0);
  const [serialkeyval, setSerialkeyval] = useState(null);
  const [confirmpasserror, setConfirmpasserror] = useState("");
  const [confirmSerialkeyval, setConfirmSerialkeyval] = useState("");
  const [devicetype, setDevicetype] = useState(0);
  const [checkingboxmessge, setCheckingboxmessge] = useState(false);

  const serialkey = useRef();
  const confirmserialkey = useRef();
  const device_type = useRef();
  const cmodule = useRef();
  const m_module = useRef();
  const [errorMessege, setErrorMessege] = useState(false);
  const [deviceid, setDeviceid] = useState(null);
  const [selSerialKey, setSelSerialKey] = useState(null);

  const [serialkeyes, setSerialkey] = useState(null);

  const [deviceModal, setDeviceModal] = useState(false);
  const [distributorDeviceModal, setdistributorDeviceModal] = useState(false);
  const [ownerDeviceModal, setownerDeviceModal] = useState(false);
  const deviceToggleModal = () => setDeviceModal(!deviceModal);
  const distributorDeviceToggleModal = () => {
    setdistributorDeviceModal(!distributorDeviceModal);
    // navigation('/');
  };
  const ownerDeviceToggleModal = () => {
    setownerDeviceModal(!ownerDeviceModal);
    // navigation('/');
  };

  const [successModal, setSuccessModal] = useState(false);
  const successToggleModal = () => setSuccessModal(!successModal);

  const [deleteModal, setDeleteModal] = useState(false);
  const deleteToggleModal = () => setDeleteModal(!deleteModal);

  const [deletesuccessModal, setDeletesuccessModal] = useState(false);
  const deletesuccessToggleModal = () =>
    setDeletesuccessModal(!deletesuccessModal);

  const [editdeviceModal, setEditdeviceModal] = useState(false);
  const editdeviceToggleModal = () => setEditdeviceModal(!editdeviceModal);

  const [successeditdeviceModal, setSuccesseditdeviceModal] = useState(false);
  const successeditdeviceToggleModal = () =>
    setSuccesseditdeviceModal(!successeditdeviceModal);

  const [deregistersuccessfulModal, setDeregistersuccessfulModal] =
    useState(false);
  const deregistersuccessfulToggleModal = () =>
    setDeregistersuccessfulModal(!deregistersuccessfulModal);

  const [devicekeyModal, setDevicekeyModal] = useState(false);
  const devicekeyToggleModal = () => setDevicekeyModal(!devicekeyModal);

  const [deregisterModal, setDeregisterModal] = useState(false);
  const deregisterToggleModal = () => setDeregisterModal(!deregisterModal);

  const [ViewdeviceModal, setViewdeviceModal] = useState(false);
  const viewdeviceToggleModal = () => setViewdeviceModal(!ViewdeviceModal);

  const [viewlinkedModal, setViewlinkedModal] = useState(false);
  const ViewlinkedToggleModal = () => setViewlinkedModal(!viewlinkedModal);

  const userid = localStorage.getItem("user_id");
  const user_type = localStorage.getItem("user_type");

  useEffect(() => {
    godevicelist();
  }, []);

  const HandleCmodule = () => {
    if (cmodule.current.checked) {
      setCmoduleval(1);
    } else {
      setCmoduleval(0);
    }
  };
  const handleGoToggle = () => {
    setGoToggle(true);
  };
  const handleDevice5 = () => {
    setDevice5(true);
  };
  const handleDevice6 = () => {
    setDevice6(true);
  };

  const HandlemModule = () => {
    if (m_module.current.checked) {
      setMmoduleval(1);
    } else {
      setMmoduleval(0);
    }
  };
  const handleDistributor = (event, id) => {
    setDistributorName(event);
    // alert(id)
    setFirstName1("");
    setLastName("");
    setPassword1("");
    setEmail("");
    setAddress1("");
    setAddress2("");
    setTelephone1("");
    setCity("");
    setCountry("");
    setAge("");
    setGender("");
    const url = `/get/personal/device/list/${id}`;
    // const params = {distributer:id};
    // const queryString = new URLSearchParams(params).toString();
    fetch(API_URL + `${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setPopData1(resp);
          resp.data.profile.map((item) => {
            setFirstName1(item.firstname);
            setLastName(item.lastname);
            setPassword1(item.password);
            setEmail(item.email);
            setAddress1(item.address);
            setAddress2(item.address2);
            setTelephone1(item.telephone);
            setCity(item.city);
            setCountry(item.country);
            setAge(item.age);
            setGender(item.gender);
          });
        });
      }
    });
  };
  const handleOwner = (event, id) => {
    setFirstName1("");
    setLastName("");
    setPassword1("");
    setEmail("");
    setAddress1("");
    setAddress2("");
    setTelephone1("");
    setCity("");
    setCountry("");
    setAge("");
    setGender("");
    const params = { associated_owner: id };
    setDistributorName(event);
    const url = `/get/owner/five/${id}`;
    // const params = {associated_owner:id};
    // const queryString = new URLSearchParams(params).toString();
    fetch(API_URL + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setPopData1(resp);
          resp.data.profile.map((item) => {
            setFirstName1(item.firstname == null ? "NA" : item.firstname);
            setLastName(item.lastname);
            setPassword1(item.password == null ? "NA" : item.password);
            setEmail(item.email == null ? "NA" : item.email);
            setAddress1(
              item.address == null
                ? "NA"
                : item.address == "na"
                ? item.address.toUpperCase()
                : item.address
            );
            setAddress2(
              item.address2 == null
                ? "NA"
                : item.address2 == "na"
                ? item.address2.toUpperCase()
                : item.address2
            );
            setTelephone1(item.telephone == null ? "NA" : item.telephone);
            setCity(item.city == null ? "NA" : item.city);
            setCountry(item.country == null ? "NA" : item.country);
            setAge(item.age == null ? "NA" : item.age);
            setGender(item.gender == null ? "NA" : item.gender);
          });
        });
      }
    });
  };

  const SaveDevice = () => {
    let data = {};

    if (
      validator.trim(serialkey.current.value) == "" ||
      device_type.current.value == "null"
    ) {
      setErrorMessege(true);
      return false;
    }

    data["serial_key"] = validator.trim(serialkey.current.value);
    data["distributer"] = userid;
    data["device_type"] = device_type.current.value;
    data["c_module"] = cmoduleval;
    data["m_module"] = mmoduleval;

    fetch(API_URL + "/create/personal/device", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          deviceToggleModal();
          successToggleModal();
          godevicelist();
          setCmoduleval(0);
          setMmoduleval(0);
        });
      } else if (response.status == 400) {
        devicekeyToggleModal();
      } else {
        alert("network error");
      }
    });
  };

  const godevicelist = () => {
    let url = "/get/personal/device/list";
    const params = { owner: _ownnerId };
    const queryString = new URLSearchParams(params).toString();
    url = `${url}?${queryString}`;
    fetch(API_URL + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        // response.json().then((resp) => {
        //     let _temp = [];
        //     resp.data.map((v, i) => {
        //         _temp.push({
        //             distributor: v.firstname == null ? "Profile Incomplete" : <u className='pointer-curser' onClick={()=>{handleDistributor(v.firstname + v.lastname, v.distributer);setdistributorDeviceModal(!distributorDeviceModal);}} style={{color:'rgb(77, 0, 77)', cursor:'pointer'}}>{v.firstname + " "} {v.lastname}</u>,
        //             serialkey: v.serial_key,
        //             devicetype:   v.device_type == "5" ?  "GO Personal" + ( v.c_module == 1 ?  "(C)" : "") + ( v.m_module == 1 ? "(M)" : "")  : v.device_type == 6  ? "GO Basic" : v.device_type == 7 ? "GO Professional" : "No device type",
        //             dateactivate: v.date_activated == null ? "Not activated" : v.date_activated == 0 ? "NA" : new Date(v.date_activated * 1000).toLocaleDateString(),
        //             created: v.created == null ? "Not created" : v.created == 0 ? "NA" : new Date(v.created).toLocaleDateString(),
        //             expires_at: v.expires_at == null ? "Not expires_at" : v.expires_at == 0 ? "NA" : new Date(v.expires_at * 1000).toLocaleDateString(),
        //             download: v.downlaoded == 0 ? "No" : "Yes",

        //             action: <ul className="action-list">

        //                 <li>
        //                     <Tooltip classes={{
        //                         tooltip: classes.customTooltip,

        //                     }} title="Registration History" placement="top"><a href="javascript:void(0)" onClick={() => viewdevicepopup(v.serial_key)} className="view-patient" ><img src={logimg} /></a></Tooltip>
        //                     {/* <Tooltip classes={{
        //                         tooltip: classes.customTooltip,

        //                     }} title="Linked Log" placement="top"><a href="javascript:void(0)" onClick={() => viewlinkedpopup(v.serial_key)} className="view-patient" ><img src={logimg} /></a></Tooltip> */}

        //                     {v.date_activated == 0 || v.date_activated == null ? <><Tooltip classes={{
        //                         tooltip: classes.customTooltip,

        //                     }} title="Edit" placement="top"><a href="javascript:void(0)" onClick={() => edittempopUp(v.id)} className="view-patient" ><i className="fa fa-pencil-square-o" aria-hidden="true"></i></a></Tooltip>  <Tooltip classes={{
        //                         tooltip: classes.customTooltip,

        //                     }} title="Delete" placement="top"><a href="javascript:void(0)" onClick={() => deleteItempopUp(v.id)} className="view-patient" ><i className="fa fa-trash" aria-hidden="true"></i></a></Tooltip> </> : <><Tooltip classes={{
        //                         tooltip: classes.customTooltip,

        //                     }} title="De-register" placement="top"><a href="javascript:void(0)" onClick={() => deRegisterpopup(v.id,v.serial_key)} className="view-patient" ><i className="fa fa-user-times" aria-hidden="true"></i></a></Tooltip>

        //                     </>
        //                     }
        //                 </li>
        //             </ul>

        //         })
        //     })
        //     setData(_temp);

        // });
        response.json().then((resp) => {
          let _temp = [];
          resp.data.map((v, i) => {
            _temp.push({
              distributor:
                v.firstname == null ? (
                  "Profile Incomplete"
                ) : (
                  <u
                    className="pointer-curser"
                    onClick={() => {
                      handleDistributor(
                        v.firstname + v.lastname,
                        v.distributer
                      );
                      setdistributorDeviceModal(!distributorDeviceModal);
                    }}
                    style={{ color: "rgb(77, 0, 77)", cursor: "pointer" }}
                  >
                    {v.firstname + " "}
                    {v.lastname}
                  </u>
                ),
              serialkey: v.serial_key,
              devicetype:
                v.device_type == "5"
                  ? "GO Personal" +
                    (v.c_module == 1 ? "(C)" : "") +
                    (v.m_module == 1 ? "(M)" : "")
                  : v.device_type == 6
                  ? "GO Basic"
                  : v.device_type == 7
                  ? "GO Professional"
                  : "No device type",
              dateactivate:
                v.date_activated == null
                  ? "Not activated"
                  : v.date_activated == 0
                  ? "NA"
                  : new Date(v.date_activated * 1000).toLocaleDateString(),
              created:
                v.created == null
                  ? "Not created"
                  : v.created == 0
                  ? "NA"
                  : new Date(v.created).toLocaleDateString(),
              expires_at:
                v.expires_at == null
                  ? "Not expires_at"
                  : v.expires_at == 0
                  ? "NA"
                  : new Date(v.expires_at * 1000).toLocaleDateString(),
              download: v.downlaoded == 0 ? "No" : "Yes",
              action: (
                <ul className="action-list">
                  <li>
                    <Tooltip
                      classes={{
                        tooltip: classes.customTooltip,
                      }}
                      title="Registration History"
                      placement="top"
                    >
                      <a
                        href="javascript:void(0)"
                        onClick={() => viewdevicepopup(v.serial_key)}
                        className="view-patient"
                      >
                        <img src={logimg} />
                      </a>
                    </Tooltip>
                    {v.date_activated == 0 || v.date_activated == null ? (
                      user_type != 8 && (
                        <>
                          {/* <Tooltip
                                      classes={{
                                        tooltip: classes.customTooltip,
                                      }}
                                      title="Edit"
                                      placement="top"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => edittempopUp(v.id)}
                                        className="view-patient"
                                      >
                                        <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                      </a>
                                    </Tooltip> */}
                          <Tooltip
                            classes={{
                              tooltip: classes.customTooltip,
                            }}
                            title="Delete"
                            placement="top"
                          >
                            <a
                              href="javascript:void(0)"
                              onClick={() => deleteItempopUp(v.id)}
                              className="view-patient"
                            >
                              <i className="fa fa-trash" aria-hidden="true"></i>
                            </a>
                          </Tooltip>
                        </>
                      )
                    ) : (
                      <>
                        {user_type != 8 && (
                          <Tooltip
                            classes={{
                              tooltip: classes.customTooltip,
                            }}
                            title="De-register"
                            placement="top"
                          >
                            <a
                              href="javascript:void(0)"
                              onClick={() =>
                                deRegisterpopup(v.id, v.serial_key)
                              }
                              className="view-patient"
                            >
                              <i
                                className="fa fa-user-times"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </Tooltip>
                        )}
                      </>
                    )}
                  </li>
                </ul>
              ),
            });
          });

          _temp.sort((a, b) => {
            const distributorA = a.distributor.toLowerCase();
            const distributorB = b.distributor.toLowerCase();

            if (distributorA < distributorB) {
              return -1;
            }
            if (distributorA > distributorB) {
              return 1;
            }
            return 0;
          });

          setData(_temp);
        });
      }
    });
  };

  const deleteItempopUp = (id) => {
    if (deleteModal == false) {
      setDeviceid(id);
      setDeleteModal(!deleteModal);
    } else {
      setDeviceid(id);
      setDeleteModal(deleteModal);
    }
  };

  const edittempopUp = (id) => {
    if (editdeviceModal == false) {
      setDeviceid(id);
      setEditdeviceModal(!editdeviceModal);
    } else {
      setDeviceid(id);
      setEditdeviceModal(editdeviceModal);
    }
  };

  const viewdevicepopup = (key) => {
    if (ViewdeviceModal == false) {
      setSerialkey(key);
      setViewdeviceModal(!ViewdeviceModal);
    } else {
      setSerialkey(key);
      setViewdeviceModal(ViewdeviceModal);
    }
  };

  const viewlinkedpopup = (key) => {
    setSerialkey(key);
    setViewlinkedModal(!viewlinkedModal);
  };

  const deleteDevice = () => {
    fetch(API_URL + "/delete/personal/device/" + deviceid, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          godevicelist();
          deleteToggleModal();
          deletesuccessToggleModal();

          // const interval = setInterval(() => {
          //     location.reload("/")

          // }, 3000);
          // return () => clearInterval(interval);
        });
      } else {
        alert("Network error");
      }
    });
  };

  const chackValidationserialkey = () => {
    if (serialkeyval != confirmserialkey.current.value) {
      setConfirmpasserror("Serial key should match");
    } else {
      setConfirmpasserror("");
    }

    setConfirmSerialkeyval(confirmserialkey.current.value);
  };

  const HandleSerialkey = () => {
    if (confirmSerialkeyval != serialkey.current.value) {
      setConfirmpasserror("Serial key should match");
    } else {
      setConfirmpasserror("");
    }

    setSerialkeyval(serialkey.current.value);

    var val = serialkey.current.value;
    if (val == 0) {
      setErrorMessege(true);
    } else {
      setErrorMessege(false);
    }
  };

  const HandledeviceType = () => {
    var val = device_type.current.value;

    setDevicetype(device_type.current.value);

    setCmoduleval(0);
    setMmoduleval(0);

    if (val == 5) {
      setCheckboxshow(true);
      setCheckingboxmessge(true);
    } else {
      setCheckboxshow(false);
      setCheckingboxmessge(false);
    }

    if (val == "null") {
      setErrorMessege(true);
    } else {
      setErrorMessege(false);
    }
  };

  const deRegisterpopup = (id, _serial) => {
    if (deregisterModal == false) {
      setDeviceid(id);
      setSelSerialKey(_serial);
      setDeregisterModal(!deregisterModal);
    } else {
      setDeviceid(id);
      setSelSerialKey(_serial);
      setDeregisterModal(deregisterModal);
    }
  };

  const deregister = () => {
    let data = {};

    data["serial_key"] = selSerialKey;
    data["user"] = userid;

    fetch(API_URL + "/add/device/five/history/" + deviceid, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          godevicelist();
          deregistersuccessfulToggleModal();
          deregisterToggleModal();

          // const interval = setInterval(() => {
          //     location.reload("/")

          // }, 3000);
          // return () => clearInterval(interval);
        });
      } else if (response.status == 400) {
        devicekeyToggleModal();
      } else {
        alert("network error");
      }
    });
  };

  const columns = [
    {
      title: "Distributor",
      field: "distributor",
      width: "200px",
      cellStyle: {
        textTransform: "capitalize",
      },
    },
    {
      title: "Serial key",
      field: "serialkey",
    },

    {
      title: "Downloaded",
      field: "download",
    },
    {
      title: "Activated Date",
      field: "dateactivate",
      cellStyle: {
        textTransform: "capitalize",
      },
    },
    {
      title: "Created Date",
      field: "created",
      cellStyle: {
        textTransform: "capitalize",
      },
    },
    {
      title: "Expiration Date",
      field: "expires_at",
    },
    {
      title: <span className="text-right">Action</span>,
      field: "action",
    },
  ];
  const columnsDistributor = [
    {
      title: "Customer",
      field: "ownername",
    },
    {
      title: "Serial key",
      field: "serialkey",
    },

    {
      title: "Downloaded",
      field: "download",
    },
    {
      title: "Activated Date",
      field: "dateactivate",
    },
    {
      title: "Created Date",
      field: "created",
    },
    {
      title: "Expiration Date",
      field: "expires_at",
    },
    {
      title: "Device type",
      field: "devicetype",
    },
    {
      title: <span className="text-right">Action</span>,
      field: "action",
    },
  ];
  const columnsOwner = [
    {
      title: "Distributor",
      field: "distributor",
    },
    {
      title: "Serial key",
      field: "serialkey",
    },

    {
      title: "Downloaded",
      field: "download",
    },
    {
      title: "Activated Date",
      field: "dateactivate",
    },
    {
      title: "Created Date",
      field: "created",
    },
    {
      title: "Expiration Date",
      field: "expires_at",
    },
    {
      title: "Device type",
      field: "devicetype",
    },
    {
      title: <span className="text-right">Action</span>,
      field: "action",
    },
  ];
  // ===========================
  const columns1 = [
    {
      title: "Id",
      field: "id",
    },
    {
      title: "Serial key",
      field: "serial_key",
    },
    {
      title: "Expiration Date",
      field: "expires_at",
    },

    {
      title: "Activate Date",
      field: "date_activate",
    },
    {
      title: "Co2 Calibration",
      field: "co2_calibration",
    },
    {
      title: "Internal Id",
      field: "internal_id",
    },
  ];
  // ===================

  const handleGoDevice = () => {
    navigation("/");
  };
  const handleDevice = () => {
    navigation("/maintenance7");
  };

  return (
    <div className="wrp-bankform">
      <div className="mobiletable">
        <div style={{ maxWidth: "100%" }}>
          {data.length > 0 ? (
            <MaterialTable
              options={{
                search: true,
                showTitle: false,
                // toolbar: true,
                pageSize:
                  data?.length <= 5
                    ? 5
                    : data?.length > 5 && data?.length <= 10
                    ? 10
                    : data?.length > 10 && data?.length <= 20
                    ? 20
                    : data?.length > 20 && data?.length <= 30
                    ? 30
                    : data?.length > 30 && data?.length <= 40
                    ? 40
                    : data?.length > 40 && data?.length <= 50
                    ? 50
                    : data?.length > 50 && data?.length <= 100
                    ? 100
                    : 150,
                pageSizeOptions: [5, 10, 20, 50, 100, 150],
              }}
              columns={columns}
              data={data}
              title=""
            />
          ) : (
            <MaterialTable
              options={{
                search: true,
                showTitle: false,
                // toolbar: true,
                pageSize: [
                  data.length <= 5
                    ? 5
                    : data.length > 5 && data.length <= 10
                    ? 10
                    : data.length < 10 && data.length <= 20
                    ? 20
                    : data.length > 20 && data.length <= 50
                    ? 50
                    : data.length > 50 && data.length <= 100
                    ? 100
                    : 150,
                ],
                pageSizeOptions: [5, 10, 20, 50, 100, 150],
              }}
              columns={columns}
              title=""
            />
          )}
        </div>
      </div>

      <Modal
        isOpen={ownerDeviceModal}
        toggle={ownerDeviceToggleModal}
        className="connect-box1"
        centered={true}
      >
        <ModalHeader toggle={ownerDeviceToggleModal}>Owner Profile</ModalHeader>
        {/* <div style={{borderBottom:"1px solid #212529" , paddingBottom:'40px'}}> */}
        <div
          style={{ borderBottom: "1px solid #212529", paddingBottom: "40px" }}
        >
          <div className="row-main" style={{ padding: "0 15px" }}>
            <div className="row">
              <div className="col-md-6">
                <span className="val-span">
                  <span className="names-cls">First Name: </span>
                  {firstName1}
                </span>
                <br />
                <span className="val-span">
                  <span className="names-cls">Last Name: </span>
                  {lastName}
                </span>
                <br />
                <span className="val-span">
                  <span className="names-cls">Email: </span>
                  {email}
                </span>
                <br />
                <span className="val-span">
                  <span className="names-cls">Password: </span>
                  {password1}
                </span>
                <br />
              </div>
              <div className="col-md-3">
                <span className="val-span">
                  <span className="names-cls">Telephone: </span>
                  {telephone1}
                </span>
                <br />
                <span className="val-span">
                  <span className="names-cls">Address 1:</span>
                  {address1}
                </span>
                <br />
                <span className="val-span">
                  <span className="names-cls">Address 2 : </span>
                  {address2}
                </span>
                <br />
                <span className="val-span">
                  <span className="names-cls">City : </span>
                  {city}
                </span>
                <br />
              </div>
              <div className="col-md-3">
                <span className="val-span">
                  <span className="names-cls">Age :</span>
                  {age}
                </span>
                <br />
                <span className="val-span">
                  <span className="names-cls">Gender :</span>
                  {gender}
                </span>
                <br />
                {/* <span className='val-span'>Postal Code :{postalCode}</span><br /> */}
              </div>
            </div>
          </div>
        </div>
        <ModalBody>
          <div className="add-btn-wrp add-btn-wrp2">
            <div className="button-div">
              <Accordion className="main-accordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Device GO</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    {data7.length > 0 ? (
                      <MaterialTable
                        options={{
                          search: true,
                          showTitle: false,
                          // toolbar: true,
                          pageSize: [
                            data7.length >= 5
                              ? 5
                              : data7.length > 5 && data7.length <= 10
                              ? 10
                              : data7.length < 10 && data7.length <= 20
                              ? 20
                              : data7.length > 20 && data7.length <= 50
                              ? 50
                              : data7.length > 50 && data7.length <= 100
                              ? 100
                              : 150,
                          ],
                          pageSizeOptions: [5, 10, 20, 50, 100, 150],
                        }}
                        columns={columnsOwner}
                        data={data7}
                        title=""
                      />
                    ) : (
                      <MaterialTable
                        options={{
                          search: true,
                          showTitle: false,
                          // toolbar: true,
                          pageSize: [
                            data7.length >= 5
                              ? 5
                              : data7.length > 5 && data7.length <= 10
                              ? 10
                              : data7.length < 10 && data7.length <= 20
                              ? 20
                              : data7.length > 20 && data7.length <= 50
                              ? 50
                              : data7.length > 50 && data7.length <= 100
                              ? 100
                              : 150,
                          ],
                          pageSizeOptions: [5, 10, 20, 50, 100, 150],
                        }}
                        columns={columnsOwner}
                        title=""
                      />
                    )}
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Device 6.0</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    {data7.length > 0 ? (
                      <MaterialTable
                        options={{
                          search: true,
                          showTitle: false,
                          // toolbar: true,
                          pageSize: [
                            data7.length >= 5
                              ? 5
                              : data7.length > 5 && data7.length <= 10
                              ? 10
                              : data7.length < 10 && data7.length <= 20
                              ? 20
                              : data7.length > 20 && data7.length <= 50
                              ? 50
                              : data7.length > 50 && data7.length <= 100
                              ? 100
                              : 150,
                          ],
                          pageSizeOptions: [5, 10, 20, 50, 100, 150],
                        }}
                        columns={columnsOwner}
                        data={data7}
                        title=""
                      />
                    ) : (
                      <MaterialTable
                        options={{
                          search: true,
                          showTitle: false,
                          // toolbar: true,
                          pageSize: [
                            data7.length >= 5
                              ? 5
                              : data7.length > 5 && data7.length <= 10
                              ? 10
                              : data7.length < 10 && data7.length <= 20
                              ? 20
                              : data7.length > 20 && data7.length <= 50
                              ? 50
                              : data7.length > 50 && data7.length <= 100
                              ? 100
                              : 150,
                          ],
                          pageSizeOptions: [5, 10, 20, 50, 100, 150],
                        }}
                        columns={columnsOwner}
                        title=""
                      />
                    )}
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Device 5.0</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {/* <Typography>
          <MaterialTable
                                    options={{
                                        search: true,
                                        showTitle: false,
                                        // toolbar: true,
                                        pageSize: [data7.length<10 ? (20):
                                            data7.length<20 ? (40):
                                            data7.length<30 ? (40):
                                            data7.length<40 ? (50):
                                            data7.length<50 ? (60):
                                            100],
                                        pageSizeOptions: [
                                            data7.length<10 ? (20):
                                            data7.length<20 ? (40):
                                            data7.length<30 ? (40):
                                            data7.length<40 ? (50):
                                            data7.length<50 ? (60):
                                            data7.length<60 && 70,80,120,150
                                        ]
                                    }}
                                    columns={columnsOwner}
                                    data={data7}
                                    title=""
                                />
          </Typography> */}
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
          {/* </div> */}
        </ModalBody>
      </Modal>
      {/* ====================================================================== */}

      <Modal
        isOpen={deviceModal}
        toggle={deviceToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={deviceToggleModal}>
          <span className="ml-1 roititle ">Add</span>
        </ModalHeader>
        <ModalBody>
          <div>
            <ul className="deviceformlist">
              <li>
                <div className="input-group mb-3 device-input">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      GO-
                    </span>
                  </div>
                  <input
                    type="number"
                    placeholder="Write serial key"
                    ref={serialkey}
                    onChange={HandleSerialkey}
                  />
                </div>
                <div className="input-group mb-3 device-input">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      GO-
                    </span>
                  </div>

                  <input
                    type="number"
                    placeholder="Confirm serial key"
                    ref={confirmserialkey}
                    onChange={chackValidationserialkey}
                  />

                  <p className="passworderror">{confirmpasserror}</p>
                </div>
                <div className="select-device-type">
                  <select onChange={HandledeviceType} ref={device_type}>
                    <option value="null">Select device type</option>
                    <option value="5">GO Personal</option>
                    <option value="6">GO Basic</option>
                    <option value="7">GO Professional</option>
                  </select>

                  {checkboxshow && (
                    <div className="wrp-checkbox-module">
                      <input
                        type="checkbox"
                        onChange={HandleCmodule}
                        ref={cmodule}
                      />
                      <label className="c_module">C module</label>{" "}
                      <input
                        type="checkbox"
                        onChange={HandlemModule}
                        className="mrl-module"
                        ref={m_module}
                      />{" "}
                      <label>M module</label>
                    </div>
                  )}

                  {cmoduleval == 1 &&
                  mmoduleval == 1 &&
                  devicetype == 5 &&
                  checkingboxmessge == true ? (
                    <p>
                      Please note that checking off C-module and M-module
                      checkboxes together will make this a GO Basic device.
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                {errorMessege && (
                  <p className="error-message">All required field</p>
                )}
              </li>

              <li>
                <div className="addBtn">
                  <button onClick={SaveDevice}>Add</button>
                </div>
              </li>
            </ul>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={successModal}
        toggle={successToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={successToggleModal}>
          <span className="ml-1 roititle ">Successfull</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>Serial key has been added successfully</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={deleteModal}
        toggle={deleteToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalBody>
          <div className="deletemodal-content">
            <h6>
              <i
                onClick={() => setDeleteModal(false)}
                className="fa fa-times"
                aria-hidden="true"
              ></i>
            </h6>
            <div className="deleteCircle">
              <i className="fa fa-trash" aria-hidden="true"></i>
            </div>
            <h3>Are you sure?</h3>
            <p className="para">
              Do you really want to delete the record? This process cannot be
              undone.
            </p>

            <div className="butn-wrp">
              <button className="delete-cancel-btn" onClick={deleteToggleModal}>
                Cancel
              </button>
              <button onClick={deleteDevice}>Delete</button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={deletesuccessModal}
        toggle={deletesuccessToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={deletesuccessToggleModal}>
          <span className="ml-1 roititle ">Successfull</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>Serial Key has been deleted successfully</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={editdeviceModal}
        toggle={editdeviceToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={editdeviceToggleModal}>
          <span className="ml-1 roititle ">Edit</span>
        </ModalHeader>
        <ModalBody>
          <EditDevice5
            deviceid={deviceid}
            editdeviceToggleModal={editdeviceToggleModal}
            successeditdeviceToggleModal={successeditdeviceToggleModal}
            godevicelist={godevicelist}
            devicekeyToggleModal={devicekeyToggleModal}
          />
        </ModalBody>
      </Modal>

      <Modal
        isOpen={successeditdeviceModal}
        toggle={successeditdeviceToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={successeditdeviceToggleModal}>
          <span className="ml-1 roititle ">Successfull</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>Device type has been updated successfully</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={devicekeyModal}
        toggle={devicekeyToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={devicekeyToggleModal}>
          <span className="ml-1 roititle ">Error</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>A device already exists with this Serial key.</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={deregisterModal}
        toggle={deregisterToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={deregisterToggleModal}>
          <span className="ml-1 roititle ">De-register</span>
        </ModalHeader>
        <ModalBody>
          <div className="deletemodal-content">
            <p className="para">
              Do you really want to de-register this device?
            </p>

            <div className="butn-wrp">
              <button
                className="delete-cancel-btn"
                onClick={deregisterToggleModal}
              >
                No
              </button>
              <button
                style={{ backgroundColor: "rgb(77, 0, 77)" }}
                onClick={deregister}
              >
                Yes
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={deregistersuccessfulModal}
        toggle={deregistersuccessfulToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={deregistersuccessfulToggleModal}>
          <span className="ml-1 roititle ">Successfull</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>Device Successfully de-registered</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={ViewdeviceModal}
        toggle={viewdeviceToggleModal}
        className="viewlog"
        centered={true}
      >
        <ModalHeader toggle={viewdeviceToggleModal}>
          <span className="ml-1 roititle ">Device seven history list</span>
        </ModalHeader>
        <ModalBody>
          <Viewlog serialkeyes={serialkeyes} />
        </ModalBody>
      </Modal>

      <Modal
        isOpen={viewlinkedModal}
        toggle={ViewlinkedToggleModal}
        className="viewlog"
        centered={true}
      >
        <ModalHeader toggle={ViewlinkedToggleModal}>
          <span className="ml-1 roititle ">Device seven history list</span>
        </ModalHeader>
        <ModalBody>
          <Viewlinkedlog serialkeyes={serialkeyes} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default GodeviceOwnerAccordian5;
